export default __webpack_public_path__ + "static/media/land-tile.1bbd26d1.png";